import * as MapsActionCreators from './maps'
import * as ToolsActionCreators from './tools'
export default {
    ...MapsActionCreators,
    ...ToolsActionCreators
}